import React from "react";
import { Box, Heading, Text } from "@chakra-ui/react";
import { FormattedMessage } from "react-intl";

const Header = ({ HeaderText, HeaderDescription }) => {
  return (
    <Box>
      <Heading as="h2" size="xl" fontWeight="bold" color="black" mb={2}>
        <FormattedMessage id={HeaderText} />
      </Heading>
      {HeaderDescription && (
        <Text fontSize="lg" color="gray.500">
          <FormattedMessage id={HeaderDescription} />
        </Text>
      )}
    </Box>
  );
};

export default Header;
